// Ionic Starter App

// angular.module is a global place for creating, registering and retrieving Angular modules
// 'starter' is the name of this angular module example (also set in a <body> attribute in index.html)
// the 2nd parameter is an array of 'requires'
angular.module('internal', [
    'ionic',
    'ngMaterial',
    'ngMessages',
    'LocalStorageModule',
    'moment-picker',
    'ngFileUpload',
    'pullToRefresh',
    'shared',
    'internalTemplate',
    'internal.login',
    'internal.parkingarea',
    'internal.chargingrequest',
    'internal.profile',
    'internal.home',
    'internal.homecharges',
    'internal.mycharges',
    'internal.events',
    'internal.eventdetail',
    'internal.imageviewer',
    'internal.clientselector',
    'internal.addclient',

    'internal.addevent-v2',
    'internal.addclient-v2',
    'internal.about',
    'internal.slidenavleft',
    'internal.changepassword',
    //booking
    'internal.vehiclebookings',
    'internal.chargebookings',
    'internal.forgotpassword',
    'internal.resetpassword',
    'internal.fuellimit',
    'internal.changelanguage',
    'internal.notifications',
    'internal.chargingvehicle',
    'internal.announcements',
    'internal.documents'
    ]).run(
    /**
     *
     * @param $rootScope
     * @param AuthService{AuthService}
     * @param $state
     * @param localStorageService{localStorageService}
     * @param $ionicScrollDelegate
     * @param $timeout{angular.ITimeoutService}
     * @param $http
     * @param $mdDialog
     * @param $translationService{$translationService}
     * @param UtilityService{UtilityService}
     * @param NotificationService{NotificationService}
     * @param RequestRejector{RequestRejector}
     * @param DeviceService{DeviceService}
     * @param $ionicPlatform{$ionicPlatform}
     * @param $interval{angular.IIntervalService}
     * @param $mdBottomSheet
     */
        function ($rootScope, AuthService, $state, localStorageService, $ionicScrollDelegate, $timeout, $http, $mdDialog, $translationService, UtilityService, NotificationService, RequestRejector, DeviceService, $ionicPlatform, $interval, $mdBottomSheet) {


        // Call Each change url
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {

            // console.log('--stateChangeStart to ', toState);

            // with temporary state when the translation loading we ignore until it load
            if (toState.name === 'empty' && $translationService.isLoading()) { return; }
            //Stop all request
            $rootScope.stopAllRequestData();

            //Close all popup
            $mdDialog.cancel();

            if (!$translationService.isTranslationLoaded()) {
                event.preventDefault();

                // console.log('---loading translation');
                $translationService.loadTranslation().then(x => {
                    // console.log('---load translation [DONE]');

                    
                    if (toState.name === 'empty') {
                        $state.go('internal.home');
                    } else {
                        $state.go(toState.name, toParams);
                    }

                });

                $state.go('empty');

                return;
            }

            if (AuthService.isLoggedIn()) {
                if (toState.name == "internal.login") {
                    event.preventDefault();
                    $state.go('internal.home');
                } else if (toState.name == "internal.forgotpassword" || toState.name == "internal.resetpassword") {
                    AuthService.logout().then(() => {
                        event.preventDefault();
                        $state.go(toState.name, toParams);
                    });
                } else if (toState.name !== 'internal.home') {
                    // this variable is for first time that application not yes refload all home screen data
                    if (!$rootScope['home-refresh-finish']) {
                        event.preventDefault();
                        AuthService.refreshHomeData().then(function (data) {
                            $state.go(toState.name, toParams);
                        });
                    }
                }
            } else {
                if (["internal.login", "internal.forgotpassword", "internal.resetpassword"].indexOf(toState.name) < 0) {
                    event.preventDefault();
                    $state.go('internal.login');
                }
            }
        });

        // NF-834: Track route
        $rootScope.$on('$stateChangeSuccess',(event, toState, toParams)=>{
            let url = toState.url;
            for(let property in toParams){
                url =  url.replace(":"+property, toParams[property])
            }
            console.log('[Screen] '+ url);
        })
        $rootScope.$on('$stateChangeError',(event, toState, toParams)=>{
            console.error('$stateChangeError:', toState);
        });


        //stopAllRequestData
        $rootScope.stopAllRequestData = function () {
            angular.forEach($http.pendingRequests, function (request) {
                // Don't stop request if have flag ignoreAutoStopRequest
                if(request.headers && request.headers.ignoreAutoStopRequest) {
                    return;
                }
                $http.abort(request);
            });
        }

        $rootScope.$on('unauthorized', function (ev, response) {
            if (response && response.data && response.data.code === "InvalidAuthorization") {
                // Stop all request
                $rootScope.stopAllRequestData();
                // Close all popup
                $mdDialog.cancel();
                // Close all current bottom sheets
                $mdBottomSheet.cancel();

                localStorageService.remove("user");
                $state.go('internal.login');

                
            }
        });
        




        //Prevent ionic scroll if input has Class no-scroll
        var isKeyboardElementDefault = ionic.tap.isKeyboardElement;
        ionic.tap.isKeyboardElement = function (element) {
            if ($(element).hasClass("no-scroll"))
                return false;
            return isKeyboardElementDefault(element);
        }

        // NF-819:// Disable ionic keyboard
        ionic.keyboard.disable();

        //add class to ng-app
        $("body").addClass($("body").attr("ng-app"));

        $rootScope.gotoAddEventPage = function (prevState) {
            $timeout(function () {
                $state.go('internal.addevent-v2', {
                    prevState: prevState
                });

                /*
                if ($Config.eventsV2()) {
                    $state.go('internal.addevent-v2', {
                        prevState: prevState
                    })
                }
                else {
                    $state.go('internal.addevent', {
                        prevState: prevState
                    })
                }
                */
            }, 100);
        }
        

        // Only for Cordova app
        if(DeviceService.isOnCordova()){
            //add class to cordova
            $("body").addClass('cordova');
            if (ionic.Platform.isIOS()) {
                if(window.HomeIndicatorPlugin){
                    window.HomeIndicatorPlugin.setHomeIndicatorColor('#ffffff');
                }
            }

            if (ionic.Platform.isAndroid()) {
                // NF-928: Keep the font size defined for the application, don't use system font-size, prevent zoom font-size
                if(window['Utility']) {
                    window['Utility'].setTextZoom(100);
                }
                
                
                
                //NF-1046, Check Inset if app run on Android >=15
                if (parseInt(device['sdkVersion']) >= 35) {
                  // @ts-ignore
                  window.totalpave.Inset.create({
                    includeRoundedCorners: false,
                    mask: window.totalpave.InsetMask['SYSTEM_BARS'] | window.totalpave.InsetMask['DISPLAY_CUTOUT']
                  }).then(( result ) => {
                    // Listen to inset changes, Update size when inset changes
                    result.addListener(( rect ) => {
                        document.documentElement.classList.add('safe-area-inset');
                      // Set status-bar-height (Top), navigation-bar-height (Bottom)
                      document.documentElement.style.setProperty('--ntk-safe-area-left', Math.ceil(rect.left) + 'px');
                      document.documentElement.style.setProperty('--ntk-safe-area-right', Math.ceil(rect.right) + 'px');
                      document.documentElement.style.setProperty('--ntk-safe-area-top', Math.ceil(rect.top) + 'px');
                      document.documentElement.style.setProperty('--ntk-safe-area-bottom', Math.ceil(rect.bottom) + 'px');
                      
                      // Variable don't update when inset changes, so we need to update it manually
                      document.body.style.setProperty('--ntk-safe-area-left', Math.ceil(rect.left) + 'px');
                      document.body.style.setProperty('--ntk-safe-area-right', Math.ceil(rect.right) + 'px');
                      document.body.style.setProperty('--ntk-safe-area-top', Math.ceil(rect.top) + 'px');
                      document.body.style.setProperty('--ntk-safe-area-bottom', Math.ceil(rect.bottom) + 'px');
                    });
                  });
                }
                
            }

            $(document).on('click', 'a', function(e)  {
                e.preventDefault();

                let $this = $(e.currentTarget),
                    href = $this.attr('href');
                    target = $this.data('inAppBrowser') || '_system'; // system open the device browser. _blank open inappbrowser
                if(href) {
                    console.log("Open url: " + href + ", target:" + target);
                    window['cordova'].InAppBrowser.open(href, target);
                }
            });


            // Register Notification
            if(window['FirebasePlugin']){
                // NF-834: Track token of notification
                // Only register notification when app login complete
                $rootScope.$on('authorized',  () => {
                    let firebaseToken = localStorageService.get('firebaseToken');
                    if(firebaseToken) {
                        console.log('Firebase token:' + firebaseToken);
                    }
                    NotificationService.register();
                });
            }


            // For Crashlytics
            if(window['FirebasePlugin']){
                FirebasePlugin.setCrashlyticsUserId(RequestRejector.getClientId());
                $rootScope.$on('authorized',  () => {
                    let user  = localStorageService.get("user");
                    console.log('Email:', user.Email);// Log email for Crashlytics
                });
            }


            // Prevent ionic auto close when app in mainscreen
            ionic.Platform.exitApp = function (){

            }

            // Prevent ionic lister backbutton, we will manual by handle
            $ionicPlatform.registerBackButtonAction(()=>{}, 100);

            // Simulator for backbutton
            DeviceService.onBackButton(() => {
                const event = new KeyboardEvent("keydown", {
                    keyCode: 27,
                    bubbles: true
                });
                document.body.dispatchEvent(event)
            })
            
            
            
            // NF-1046: Add class when show|hide keyboard
            let removeClass = ()=>{
               let container = $('html');
               container.removeClass('keyboard-will-show');
            }
            $(window).on("keyboardWillShow",()=>{
               removeClass();
               $('html').addClass('keyboard-will-show');
            });
            
           $(window).on("keyboardWillHide",()=>{
               removeClass();
            });
        }

        /**
         * NF-948: On App resume from background to foreground
         *     - Don't check if user click on notification. We only check when user only switch app.
         *     - Check urgent notifications to show ChargeHasEnded dialog
         */
        DeviceService.onResume(() => {
            // Only check notifications if only switch app . Don't check if user click on notification
            if (!NotificationService.isTapOnNotification && NotificationService.shouldCheckUrgentNotifications()) {
                // Check for any urgent notifications first
                NotificationService.checkUrgentNotifications().then(() => {
                    // Then check overall notification count
                    NotificationService.checkNotificationCount();
                });
            }
        });

        // Check urgent notifications  every 1 minutes
        $interval(() => {
            if (AuthService.isLoggedIn() && // only check if user is logged in
                moment().diff(NotificationService.lastCheckUrgentNotifications, 'seconds') >= 50 && // at least 50 seconds from last check
                NotificationService.shouldCheckUrgentNotifications() // only check if app is in foreground
            ) {
                NotificationService.checkUrgentNotifications().then(() => {
                    NotificationService.checkNotificationCount();
                });
            }
        }, 1000 * 60); // 1 minute
        
        // Auto hide SplashScreen
        let timeout = 1000; // 1000ms for browser
        if(window['cordova']){  // 1000ms for cordova
            timeout = 5000;
        }
        $timeout(function() {
            UtilityService.hideSplashscreen();
        }, timeout);

        
    })
    .config(function ($stateProvider, $urlRouterProvider, $ionicConfigProvider, $mdGestureProvider,
        $mdThemingProvider, localStorageServiceProvider, $httpProvider, momentPickerProvider) {
        //Set en local for moment
        // moment.updateLocale('en', {
        //     longDateFormat: {
        //         LT: "h:mm A",
        //         LTS: "h:mm:ss A",
        //         L: "DD/MM/YYYY",
        //         l: "D/M/YYYY",
        //         LL: "MMMM Do YYYY",
        //         ll: "MMM D YYYY",
        //         LLL: "MMMM Do YYYY LT",
        //         lll: "MMM D YYYY LT",
        //         LLLL: "dddd, MMMM Do YYYY LT",
        //         llll: "ddd, MMM D YYYY LT"
        //     }
        // });
        // moment.updateLocale('fr', {
        //     longDateFormat: {
        //         LT: "h:mm A",
        //         LTS: "h:mm:ss A",
        //         L: "DD/MM/YYYY",
        //         l: "D/M/YYYY",
        //         LL: "MMMM Do YYYY",
        //         ll: "MMM D YYYY",
        //         LLL: "MMMM Do YYYY LT",
        //         lll: "MMM D YYYY LT",
        //         LLLL: "dddd, MMMM Do YYYY LT",
        //         llll: "ddd, MMM D YYYY LT"
        //     }
        // });
        // //set en is default language
        // moment.locale('fr');


        //Config date-moment-picker
        momentPickerProvider.options({
            leftArrow: '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
            rightArrow: '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
        });

        $ionicConfigProvider.views.transition('none');
        // Turn off caching for demo simplicity's sake
        $ionicConfigProvider.views.maxCache(0);
        $ionicConfigProvider.views.swipeBackEnabled(false);
        $ionicConfigProvider.scrolling.jsScrolling(true);
        $mdGestureProvider.skipClickHijack();

    

        // customize materal design template
        var customPrimaryColors = {
            '50': '#99cffa',
            '100': '#81c4f8',
            '200': '#69b8f7',
            '300': '#50adf6',
            '400': '#38a1f4',
            '500': '#2096F3',
            '600': '#0d8aed',
            '700': '#0b7cd5',
            '800': '#0a6ebc',
            '900': '#0960a4',
            'A100': '#b1dafb',
            'A200': '#c9e6fc',
            'A400': '#e2f1fd',
            'A700': '#08528c',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': ['50', '100', '200', '300'],
            'contrastLightColors': ['400', '500'],
            'contrastStrongLightColors': ['400', '500', 'A400'] // mean that text color need strong so that is display white (no opacity)
        };
        $mdThemingProvider.definePalette('customPrimaryColors',customPrimaryColors);

        $mdThemingProvider.theme('custom-confirm')
        $mdThemingProvider.theme('default').primaryPalette('customPrimaryColors');



        localStorageServiceProvider.setStorageType('localStorage');
        localStorageServiceProvider.setPrefix("Neo-Fleet");

        //$httpProvider.defaults.timeout = 72000000;
        $httpProvider.interceptors.push('RequestRejector');


        // Ionic uses AngularUI Router which uses the concept of states
        // Learn more here: https://github.com/angular-ui/ui-router
        // Set up the various states which the app can be in.
        // Each state's controller can be found in controllers.js
        $stateProvider

        // setup an abstract state for the tabs directive
            .state('internal', {
                url: '/internal',
                views: {
                    internal: {
                        abstract: true,
                        templateUrl: 'js/internal/internal/internal.view.html'

                    }
                }

            })
            // NF-1246, To refresh page in internal
            .state('internal.empty', {
                url: '/internal_empty',
                views: {
                    content: {
                        template: ''
                    }
                }
            });
        // Temporary state when app loading translation
        $stateProvider.state('empty', {
            template: '',
            url: '/empty'
            });
        $urlRouterProvider
        .when('/resetpassword/:token', '/internal/resetpassword/:token')
        .otherwise('internal/home');
    })
    .factory('$exceptionHandler', [function() {
        return function nfExceptionHandler(exception) {
            // NF-834: Track error
            console.error(exception);
        };
    }]);
